import React, { FC } from 'react';

import { PageTitle, PageWrapper } from '../../../components';

export const Tv:FC = () => (
  <PageWrapper>
    <PageTitle title="Tv" />
  </PageWrapper>
);
